import { useEffect, useRef, useState } from "react";
import PageContainer from "../../components/PageContainer"
import { useLocation, useNavigate } from "react-router-dom";
import Loader from '../../components/Loader.jsx';
import Error from '../../components/Error.jsx';
import { useSelector } from "react-redux";
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';


// Questa è la pagina a cui si approda confermando gli acquisti nella pagina CartRecap.jsx
// Prende i dati del carrello da cartSlice (Reindirizzare in Carello o Shop in caso di refresh)
const ConfirmOrderRequest = () => {
    // Verifico che l'utente provenga dalla pagina di checkout
    // checkFrom è impostato da CheckoutPage.jsx via navigate(..., { state }).
    // Refresh o accesso diretto via URL perdono lo state -> redirect al carrello.
    const location = useLocation();
    const navigate = useNavigate();
    const checkFrom = location.state?.checkFrom;

    // Catturo i dati dal carrello e userId
    const { id } = useSelector(state => state.user);
    const { data } = useSelector(state => state.cart);

    // Invio i dati in backend
    const [sendDataStatus, setSendDataStatus] = useState('idle');
    const [sendDataError, setSendDataError] = useState(false);

    const hasFetched = useRef(false);
    useEffect(() => {
        if (hasFetched.current) return;
        if (!checkFrom) {
            navigate("/cart");
            return;
        }
        if (id && data) {
            hasFetched.current = true;
            sendData();
        }

        async function sendData() {
            setSendDataStatus('loading');
            const token = localStorage.getItem('ticino-wild-token');
            const url = `${process.env.REACT_APP_SERVER_BASE_URL}/orders/get-purchase`;
            const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
            const options = { method: 'POST', headers, body: JSON.stringify({ userId: id, productsArray: data }) };
            try {
                const response = await fetch(url, options);
                if (response.ok) {
                    const result = await response.json();
                    setSendDataStatus('succeeded');
                    if (Capacitor.isNativePlatform()) {
                        localStorage.setItem('ticino-wild-pending-checkout', JSON.stringify({
                            type: 'shop_order',
                            orderId: result.payload._id
                        }));
                        await Browser.open({ url: result.url });
                    } else {
                        window.location.href = result.url;
                    }
                } else {
                    const error = await response.json();
                    throw error
                }
            } catch (error) {
                console.error(error);
                setSendDataError(error.message || "Errore nell'invio della richiesta d'acquisto.");
                setSendDataStatus('failed')
            }
        }
    }, [id, data, checkFrom, navigate])

    return (
        <PageContainer items="center">
            <div className="min-h-96 flex flex-col gap-4 justify-center items-center">
                {sendDataStatus === 'loading' && <Loader />}
                {sendDataStatus === 'failed' && sendDataError && <Error text={sendDataError} message="Torna allo shop e riprova" />}
            </div>
        </PageContainer>
    )
}
export default ConfirmOrderRequest